






















import { defineComponent, computed } from '@vue/composition-api';
// @ts-ignore
import ShareIcon from '@/assets/icons/share.svg';
import SharedState from '@/data/SharedState';
export default defineComponent({
  components: {
    ShareIcon
  },
  props: {
    showText: {
      type: Boolean,
      default: false
    }
  },
  emits: {
    click: () => true
  },
  setup(props, context) {

    const buttonText = computed(() => {
      return props.showText ? SharedState.getText(context, 'corptube.share') : '';
    });
    return {
      buttonText
    };
  }
});

